import { useEffect, useMemo, useState } from "react";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";

export const Logos3 = ({
  heading = "Trusted by these companies",
  logos = [],
  className = "",
}) => {
  const [api, setApi] = useState(null);

  const loopedLogos = useMemo(() => {
    if (!logos.length) return [];
    return [...logos, ...logos, ...logos];
  }, [logos]);

  useEffect(() => {
    if (!api) return;
    const id = setInterval(() => {
      api.scrollNext();
    }, 2200);
    return () => clearInterval(id);
  }, [api]);

  return (
    <section className={`py-12 ${className}`}>
      <div className="container flex flex-col items-center text-center">
        <h3 className="text-xl font-bold text-pretty lg:text-2xl text-white">{heading}</h3>
      </div>
      <div className="pt-8 lg:pt-10">
        <div className="relative mx-auto flex items-center justify-center lg:max-w-5xl">
          <Carousel opts={{ loop: true, dragFree: true }} setApi={setApi}>
            <CarouselContent className="ml-0">
              {loopedLogos.map((logo, index) => (
                <CarouselItem
                  key={`${logo.id}-${index}`}
                  className="flex basis-1/3 justify-center pl-0 sm:basis-1/4 md:basis-1/5 lg:basis-1/6"
                >
                  <div className="mx-4 flex h-16 w-full shrink-0 items-center justify-center rounded-xl border border-white/15 bg-white px-6">
                    <img src={logo.image} alt={logo.description} className={logo.className || "h-8 w-auto"} />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
          <div className="absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-void to-transparent"></div>
          <div className="absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-void to-transparent"></div>
        </div>
      </div>
    </section>
  );
};